import { useLayoutEffect } from 'react'
import { markLoadStage } from '@core/analytics'

import { type TLoadStageMarkerProps } from './LoadStageMarker.types'

const markHydrateEnd = () => markLoadStage('hydrate_end')

export const LoadStageMarker = ({ children }: TLoadStageMarkerProps) => {
    markLoadStage('hydrate_start')

    useLayoutEffect(markHydrateEnd, [])

    return children
}
